import FileUpload from "@app/components/file-upload.tsx";
import { EntryFiltersModel } from "@app/data-hooks/use-entries-data.ts";
import useEntriesReceiptData from "@app/data-hooks/use-entries-receipt-data.ts";
import { uploadReceiptTableDefinition } from "@app/table-definitions/upload-receipt.table-definition.tsx";
import { Button, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { DataTable, Dialog } from "bi-lib";
import { useState } from "react";

interface Props {
    open: boolean;
    onClose: () => void;
    filters: EntryFiltersModel;
}

export default function AddReceiptModal({ open, onClose, filters }: Props) {
    const [file, setFile] = useState<File>();
    const [selectedEntries, setSelectedEntries] = useState<string[]>([]);

    const { needingReceipt, uploadReceipt } = useEntriesReceiptData({
        filters,
    });

    const handleSave = async () => {
        if (!file) {
            return;
        }
        const promises = selectedEntries.map((x) => uploadReceipt.mutateAsync({ id: x, file }));
        await Promise.all(promises);
    };

    const handleSaveAndClose = async () => {
        await handleSave();
        handleClose();
    };

    const handleClose = () => {
        setFile(undefined);
        setSelectedEntries([]);
        onClose();
    };

    const handleEntrySelect = (id: string) => {
        const index = selectedEntries.indexOf(id);
        if (index == -1) {
            setSelectedEntries([...selectedEntries, id]);
            return;
        }
        const tempEntries = [...selectedEntries];
        tempEntries.splice(index, 1);
        setSelectedEntries(tempEntries);
    };

    return (
        <Dialog open={open} maxWidth={"lg"} fullWidth onClose={handleClose}>
            <DialogTitle>Upload Receipts</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={2}>
                    <FileUpload file={file} onChange={(file) => setFile(file)} />
                    <DataTable
                        rowsPerPageOptions={[5000]}
                        label={"Entries"}
                        columns={uploadReceiptTableDefinition({
                            onSelect: handleEntrySelect,
                            selectedItems: selectedEntries,
                            rowCount: needingReceipt.data?.length ?? 0,
                        })}
                        data={needingReceipt.data ?? []}
                        queryHook={needingReceipt}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant={"outlined"} onClick={handleClose}>
                    Cancel
                </Button>
                <Button
                    variant={"contained"}
                    onClick={handleSave}
                    disabled={selectedEntries.length == 0 || file == undefined}
                >
                    Save
                </Button>
                <Button
                    variant={"contained"}
                    onClick={handleSaveAndClose}
                    disabled={selectedEntries.length == 0 || file == undefined}
                >
                    Save and Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
